module.exports = __webpack_public_path__ + "static/media/radio-button-selected-blue.eff80468.svg";